module.exports = __webpack_public_path__ + "static/media/loginBkg@2x.9aaee5ad.jpg";